import React from 'react';

import 'widgets/signalTiles/signalTile/components/settings/SignalTileSettings.scss';
import { SignalTileConfigState } from 'widgets/signalTiles/signalTile/state/config/SignalTileConfigState';
import WidgetSettingsShowDataForEditor from 'widgets/WidgetSettingsEditing/WidgetSettingsShowDataForEditor';
import WidgetSettingsBucketSizeEditor from 'widgets/WidgetSettingsEditing/WidgetSettingsBucketSizeEditor';
import WidgetSettingsNumericValueEditor from 'widgets/WidgetSettingsEditing/WidgetSettingsNumericValueEditor';
import WidgetNewportAppSettingsEditor from 'widgets/WidgetSettingsEditing/WidgetNewportAppSettingsEditor';
import { useWidgetConfigUpdater } from 'widgets/WidgetSettingsEditing/useWidgetConfigUpdater';
import { CapsuleSettingsSymbolEditor } from 'widgets/tiles/components/tile/CapsuleSettingsSymbolEditor';

export interface SignalTileSettingsProps {
    config: SignalTileConfigState;
    dispatchConfigChanged: (
        configDelta: Partial<SignalTileConfigState>
    ) => void;
    onChange?: (nextDelta: Partial<SignalTileConfigState>) => void;
}

export default function SignalTileSettings(props: SignalTileSettingsProps) {
    const { onChange, config, dispatchConfigChanged } = props;

    const { debouncedApplyWidgetConfigChange } = useWidgetConfigUpdater(
        dispatchConfigChanged,
        onChange
    );

    return (
        <div className="SignalTileSettings">
            <div className="group ">
                <CapsuleSettingsSymbolEditor
                    config={config}
                    onChange={debouncedApplyWidgetConfigChange}
                />

                <WidgetSettingsShowDataForEditor
                    config={config}
                    onChange={debouncedApplyWidgetConfigChange}
                />

                <WidgetSettingsBucketSizeEditor
                    config={config}
                    onChange={debouncedApplyWidgetConfigChange}
                />

                <WidgetSettingsNumericValueEditor
                    label="Lookback Period"
                    propertyName={'numWindows'}
                    config={config}
                    onChange={debouncedApplyWidgetConfigChange}
                    min={1}
                    max={100}
                />
            </div>

            <WidgetNewportAppSettingsEditor />
        </div>
    );
}
